import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { StoreProvider } from "@/context/StoreContext";

import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import TrackOrder from "@/pages/TrackOrder";
import Reviews from "@/pages/Reviews";
import Collections from "@/pages/Collections";
import Account from "@/pages/Account";
import ReturnDetail from "@/pages/ReturnDetail";
import { Login, Register } from "@/pages/Auth";
import { About, ReturnPolicy, ShippingPolicy, SizeGuide, FAQ, Contact } from "@/pages/StaticPages";

import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/AdminLogin";
import Dashboard from "@/admin/Dashboard";
import Analytics from "@/admin/Analytics";
import AdminOrders from "@/admin/AdminOrders";
import AdminReturns from "@/admin/AdminReturns";
import AdminShipping from "@/admin/AdminShipping";
import AdminProducts from "@/admin/AdminProducts";
import AdminInventory from "@/admin/AdminInventory";
import AdminCustomers from "@/admin/AdminCustomers";
import AdminDiscounts from "@/admin/AdminDiscounts";
import AdminReviews from "@/admin/AdminReviews";
import AdminContent from "@/admin/AdminContent";
import AdminSettings from "@/admin/AdminSettings";
import { AdminPayments, AdminAudit } from "@/admin/AdminMisc";
import { AdminCategories, AdminCollections } from "@/admin/AdminCatalog";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <StoreProvider>
          <CartProvider>
            <Toaster position="top-center" toastOptions={{ style: { fontFamily: "Plus Jakarta Sans" } }} />
            <Routes>
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:category" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/collections/:slug" element={<Collections />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
                <Route path="/track-order" element={<TrackOrder />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/account" element={<Account />} />
                <Route path="/returns/:id" element={<ReturnDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/about" element={<About />} />
                <Route path="/return-policy" element={<ReturnPolicy />} />
                <Route path="/shipping-policy" element={<ShippingPolicy />} />
                <Route path="/size-guide" element={<SizeGuide />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="returns" element={<AdminReturns />} />
                <Route path="shipping" element={<AdminShipping />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="collections" element={<AdminCollections />} />
                <Route path="inventory" element={<AdminInventory />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="discounts" element={<AdminDiscounts />} />
                <Route path="payments" element={<AdminPayments />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="audit" element={<AdminAudit />} />
                <Route path="social" element={<AdminSettings />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </CartProvider>
        </StoreProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
